import DataAccess from './constants';
import API from './API'

const path = 'bookingtickets'

export const postbookingtickets = (bookingtickets) => {
    let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);
    return api.postData(path, bookingtickets);
}
